<template>
<div>
   
  <div :class="[regInvalid ? 'show-modal' : '', 'reg-invalid-modal']">
    <div class="inner-box">
      <p class="marg-b-20">We are unable to find your vehicle.<br>Please check the Reg No. is correct.</p>
      <button type="button" @click="regInvalid=0" class="m4c-btn color-white">OKAY</button>
    </div>
  </div>
  
  <section class="hero">
    <!-- <div class="site-logo text-center pad-t-50">
      <a href="/" class="iblock"><img style="width:248px;height:auto;" src="../assets/images/logo.png"></a>
    </div> -->
 
    <wewHeader></wewHeader>

    <div class="home pad-t-120">
      <div class="container intro pad-b-60">
        <h1 class="text-center pad-b-20">GET YOUR <span class="color-blue">FREE</span> CASH OFFER NOW</h1>
        <h3 class="text-center hero-subheading color-blue marg-t-15">Join the <strong>{{ people }}</strong> people who have used us</h3>
        
        <form @submit.prevent="onRegFormSubmit">
          <div class="question" style="flex-direction:row!important;justify-content:center!important;">
              <div>
                <textbox v-bind:textbox="reg"></textbox>
                <!-- <div v-if="regInvalid" class="reg-invalid textbox-errors text-center marg-l-0">We are unable to find your vehicle.<br>Please check the Reg No. is correct.</div> -->
              </div>
              <div class="pad-lr-5 hidden-xs hidden-sm">&nbsp;</div>
              <button type="submit" class="m4c-btn get-cash-offer color-white marg-t-10">GET CASH OFFER</button>
          </div>
        </form>

      </div><!-- .container -->
     

      <div class="heres-why rel pad-b-80">
        <div class="container rel text-center">
          <div class="iblock" style="max-width: 940px;">
              <h1 class="text-center arc">SELL YOUR CAR <span class="color-blue">THE EASY WAY</span>!</h1>
              <p class="text-center pad-t-15">Money4cars is the simplest, smartest and most trusted way to sell your car today</p> 
         

              <div class="w-grid trim gutters-3x pad-t-60 pad-b-30 text-center ticks-grid-small rel">
                <div v-for="(bullet,index) in bullets" v-bind:key="index" class="w-1 w-md-1-3">
                  <div class="tick-item-small rel">{{ bullet }}</div>
                </div>
              </div>
		      </div>
        </div>
      </div>

    </div><!-- .home -->

  </section>

  <wewBlueBreak></wewBlueBreak>

  <wewFooterWhite></wewFooterWhite>

</div>
</template>

<script>
import axios from 'axios'
import textbox from '@/components/input-text'
import wewHeader from '@/components/Header'
import wewFooterWhite from '@/components/wew-footer-white'
import wewBlueBreak from '@/components/wew-blue-break'

export default {
  name: 'home',
  components: {
    textbox,
    wewHeader,
    wewFooterWhite,
    wewBlueBreak
  },
  props: {
    'app': null,
    'regpost': null
  },
  beforeMount () {
    if(this.app) {
      this.$router.push({name: 'appointment', params: { query: this.app }})
    }
    if(this.regpost) {
      this.reg.value = this.regpost
      this.onRegFormSubmit()
    }
    this.$store.dispatch('fetchPeople')
  },
  data() {
    return {
      regInvalid: false,
      reg: {
          id: 'reg',
          name: 'Registration No.',
          placeholder: 'ENTER REG',
          class: 'm4c-input',
          veeRules: { 
            required: true,
            min: 4,
            max:10,
            //regex: /\d{2}[A-Z]{1,2}\d{1,6}/gi
          },
          value: null
      },
      bullets: [
        "Backed up by Ireland’s largest used car marketplace",
        "Get a real offer, not an estimate",
        "Sell today and have a cheque in hand in 30 minutes",
        "Your offer is good for 7 days",
        "No obligation to sell",
        "We can settle any finance",
        "We can buy your car in under an hour",
        "Avoid the hassle of a lengthy private sale",
        "We transfer ownership of cars immediately"
      ]
    }
  },
  computed: {
    people() { 
      return this.formatNumber(this.$store.getters.people)
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    onRegFormSubmit() {
      // Anon login to auth with FB
      //this.$store.dispatch('anonLogin')
      
      // send the uid from the login with API call
      //const anonUid = this.$store.getters.anonUid

      // user must also be logged in before No of people incremented (onMount on next step)
      
      this.$validator.validate().then(valid => {
        if (valid) {
         
            axios.get('https://webeatweb.com/m4capi/identity.php?origin=m4cIdentity&reg=' + this.reg.value)
            .then((resp) => { 
              //console.log(resp)
              if( typeof resp.data.vehicle == 'undefined') {
                //Got a 404, no matching vehicle - or 'reg invalid'
                //console.log('Identity Lookup returned a status of: ' + resp.data.status)
                //console.log(':: ' + resp.data.title)
                //console.log(':: ' + resp.data.detail)
                this.regInvalid = 1
              } else {
                //console.log(resp)
                if (typeof resp.data.status == 'undefined') { //there will only be status in data if api error
                  
                  this.$store.dispatch('storeVehicleFromApi', resp)
                  this.$router.push('/step1')
                }
              }
            })
        }
      })
    },
/*
    isFieldDirty(fieldName) {
      for (const key in this.fields) {
            if (this.fields.hasOwnProperty(key)) {
                if(this.fields[key].name == fieldName){
                    return true
                }else{
                  return false
                }
            }
        }
        return false
    },
*/
  }
}
</script>




<style>
.intro{
  position: relative;
}
.intro:after{
  position: absolute;
  content: "";
  left: 50%;
  margin-left: -450px;
  top: 20px;
  width: 140px;
  height: 140px;
  background-image:url(../assets/images/arrow-drawn-blue.png);
  background-size: 50%;
  background-repeat: no-repeat;

}

.reg-invalid-modal.show-modal{
  position: fixed;
  display: flex;
      height:100%;
      opacity: 1;
}

.reg-invalid-modal{
display:none;
opacity: 0;
height:0;

transition: all 0.3s ease-in-out;
  position: absolute;
  z-index:9999999;
  background: rgba(30, 160, 218, 0.9);
  width: 100%;
justify-content: center;
align-items: center;

}

.reg-invalid-modal .inner-box{
  padding: 60px 30px;
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  max-width: 320px;
  height: auto;
  background: #FFF;
  border-radius: 30px;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
}

.home h1{
    font-weight: 900;
    font-size: 42px;
    text-align: center;
}



.hero-subheading{
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
}

.home:after{
  
  position: absolute;
    content: "";
    /*z-index: 9;*/
    width: 360px;
    height: 210px;
    top: 430px;
    left: 0;
    background-image: url(../assets/images/hero-car-bottom-left.png);
    background-position: left -10px;
    background-repeat: no-repeat;
    background-size: 360px;
}


@media screen and (max-width: 35.4em) { /* XS */
  .home:after{
    display: none;
  }
}


@media screen and (max-width: 47.9em) { /* SM */
  .m4c-input.has-warning{
    margin-bottom: 40px;
  }

  .home:after{
    display: none;
  }

  .intro:after{
    display:none;
  }
  
}

@media screen and (max-width: 63.9em) { /* MD */
  .home:after{
    display: none;
  }

  .intro:after{
    display:none;
  }
}

@media screen and (max-width: 63.9em) { /* LG */
  .home:after{
    display: none;
  }
}

button.m4c-btn.get-cash-offer{
  margin-top: 15px;
    font-size: 30px;
    padding: 15px 40px;
    height: 94px;
    width:360px;
}

.home p{
  font-size: 21px;
  line-height: 28px;
}

.home small{
  font-size: 16px;
}

.heres-why h1{
  font-size: 42px;
  line-height: 46px;
}
.heres-why .ticks-grid-small:before{
  position: absolute;
  content: "";
  z-index:9999;
  width: 25%;
  height: 100%;
  background-image: url(../assets/images/mid-car-left.png);
  background-position: 60px 200px;
    background-repeat: no-repeat;
    background-size: 140px;
    transform: rotate(-40deg);
    transform-origin: bottom;
}

@media screen and (max-width: 79.9em) { /* XL */
  .heres-why .ticks-grid-small:before{
    display: none;
  }

  
}

.heres-why::after{
  position: absolute;
  content: "";
  z-index:9999;
  top: 0;
  right:0;
  width: 25%;
  height: 100%;
  background-image: url(../assets/images/mid-car-right.png);
  background-position: right 300px;
  background-repeat: no-repeat;
  background-size: 260px;
}


.arc{
	background-image: url(../assets/images/arc-BG-getcash.png);
    background-position: center;
    background-size: 100%;
    padding: 70px 0 25px;
}

@media screen and (max-width: 79.9em) {
    .heres-why:after{
      display:none;
    }

  .home:after{
    display: none;
  }

}



@media screen and (max-width: 63.9em) {
	.arc{
		padding: 90px 0 5px;
	}
}


.ticks-grid-small > div{
  height: 120px;
  background:transparent;
  font-size: 18px;
  line-height: 21px;
  font-weight: 700;
}



.tick-item-small::after{
  content: "";
  position: absolute;
  top: -28px;
  left: 50%;
  margin-left: -10px;
  background-image:url(../assets/images/tick2.png);
  background-size: 100%;
  width: 20px;
  height: 20px;
}


/* -*/ 

.bottom-form{
  background-repeat: no-repeat;
  background-image:url(../assets/images/grid-BG.jpg);
  background-size: cover;
  background-position: top left;
}


.step-heading{
    font-size: 30px;
    text-align: center;
}

.submit-button{
  /*
  background-image:url(../assets/images/blue-button.png);
  background-size: cover;
  width: 100%;*/
}

.submit-button img{
 height: 121px;
}

.m4c-input{
  position: relative;
      display: inline-block;
    background: white;
    border-radius: 62px;
    border: 6px solid #008EC8!important;
    height: 94px;
    width: 360px;
    padding: 0;
    margin-top: 15px;
    -webkit-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
        -moz-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;
            box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset;

}


.m4c-input.has-warning{
  border: 6px solid red!important;
}

/*.m4c-input .v-input__slot input,*/
.m4c-input input,
.m4c-input input:active{
  text-align: center!important;
    margin-top: 19px;
    font-size: 30px;
    font-weight: 800;
    color: #000000;
    border-style: none;
    /* margin-left: 10px; */
    /* margin-right: 10px; */
    height: 40px;
    background-color: transparent;
  
}


/*.m4c-input .v-input__slot input::placeholder,*/
.m4c-input input::placeholder{
  color: #B5B5B5;
}

/* .m4c-input .v-text-field__details, */
.m4c-input .textbox-errors,
.reg-invalid.textbox-errors{
  margin: 0 0 0 0;
  position: absolute;
  display: block;
  left: 0;
  bottom: -40px;
  width: 100%;
  text-align: center;
  color: red;
}


.reg-invalid-message h3{
  font-size: 21px;
  line-height: 28px;
  font-weight: 400;
}

.submit-button{
    font-family: 'Brandon Grotesque', sans-serif!important;
}


.textbox-errors{
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-top: 6px;
    margin-left: 20px;
    color: red;
}
</style>